module.exports = __webpack_public_path__ + "img/salamdarma.4ae97184.svg";